import { Fragment } from "react";
import { Certificate } from "../Models/Certificate";
import { CertificateRow } from "./CertificateRow";
import { Card, Col, Row } from "react-bootstrap";
import { PhysicianSearchResult } from "../Models/PhysicianSearchResult";
import ClinicalStatusRow from "./ClinicalStatusRow";

interface IProps {
    isOnlyResult: boolean;
    sortedAndGroupedCertificates: Certificate[][];
    showDetails: boolean;
    physician: PhysicianSearchResult;
}

export default function CertificatesCard(props: IProps) {

    let certificatesRows = props.sortedAndGroupedCertificates.map(certificates => <CertificateRow certificateGroup={certificates} physician={props.physician} />);

    if (!props.showDetails) return null;
    return (
        <Fragment>
            <Row>
                <Col lg={12}>
                    <div className="d-flex mb-3"><Card.Text className="text-primary flex-grow-1">Certifications ({<small>Status as of {new Date().toLocaleDateString()}</small>})</Card.Text>
                    </div>
                    { props.physician.clinicalStatus &&
                        <ClinicalStatusRow clinicalStatus={props.physician.clinicalStatus}></ClinicalStatusRow>
                    }
                </Col>
                <Col>
                    {certificatesRows.length <= 0 ?
                        <Row>
                            <Col>
                                Not certified
                                <hr/>
                            </Col>
                        </Row>:
                        certificatesRows
                    }
                </Col>
            </Row>
        </Fragment >
    );

}


